import { PrivateQuery, PrivateDocument, UpsertPrivateDocument, UpsertPrivateMutation, UpsertPrivateMutationVariables } from '../types';
import { client } from '../../client';

// Roles: [Shared]
// Get private data for current user (adresses, birthdays, insurance numbers, phone numbers)
export async function getPrivate(): Promise<Readonly<PrivateQuery>> {
  try {
    const result = await client.query<PrivateQuery>({
      query: PrivateDocument,
      fetchPolicy: 'network-only',
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}

// Roles: [Shared]
// Upsert private data for current user (first name ,last name ,adresses, phone number)
export async function upsertPrivate(variables: UpsertPrivateMutationVariables): Promise<Readonly<UpsertPrivateMutation>> {
  try {
    const result = await client.mutate<UpsertPrivateMutation, UpsertPrivateMutationVariables>({
      mutation: UpsertPrivateDocument,
      variables,
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}
